import { render, staticRenderFns } from "./ManualAndReadyInvoice.vue?vue&type=template&id=12dc4ffd&scoped=true"
import script from "./ManualAndReadyInvoice.vue?vue&type=script&lang=js"
export * from "./ManualAndReadyInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc4ffd",
  null
  
)

export default component.exports